module.exports = __webpack_public_path__ + "img/home2.f7d24088.jpg";